import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface RoleConfig {
  general: string[];
  pilot: string[];
  internal: string[];
}

@Injectable({
  providedIn: 'root'
})
export class RoleConfigService {
  constructor(private http: HttpClient) {}

  getRoleConfig(): Observable<RoleConfig> {
    return this.http.get<RoleConfig>('assets/roleConfig.json');
  }
}
